// extracted by mini-css-extract-plugin
module.exports = {"main":"Home_main__16Znb","todo":"Home_todo__18WEP","todoHeader":"Home_todoHeader__hMPbs"};